import * as z from "zod/v4";

export const getBrightpearlOrderStatuses = {
  name: "getBrightpearlOrderStatuses" as const,
  input: z.object({}),
  output: z.object({
    orderStatuses: z.array(
      z.object({ statusId: z.number(), name: z.string() }),
    ),
  }),
};
